import { render, staticRenderFns } from "./UnitSample.vue?vue&type=template&id=71c226ac&scoped=true"
import script from "./UnitSample.vue?vue&type=script&lang=js"
export * from "./UnitSample.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c226ac",
  null
  
)

export default component.exports